module.exports = __webpack_public_path__ + "static/media/aosa.56fafb3f.jpg";